import { render, staticRenderFns } from "./JeepayTable.vue?vue&type=template&id=708d66d8"
import script from "./JeepayTable.vue?vue&type=script&lang=js"
export * from "./JeepayTable.vue?vue&type=script&lang=js"
import style0 from "./JeepayTable.vue?vue&type=style&index=0&id=708d66d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports